import { ConnectorLogo } from "@/components/connectors/ConnectorLogo.tsx";
import { Plug } from "lucide-react";

/**
 * The mark for an MCP server the user added themselves: the server's initial,
 * with a small plug pinned to the corner.
 *
 * No favicon. It would arrive late through the icon proxy, and the tile reads
 * as broken while it waits; the initial names the server at once. The plug is
 * what says "custom" now that the tile carries no chip for it, so the badge
 * row has room for the name.
 */
export const CustomMcpLogo = ({ name }: { name: string }) => (
  <span className="relative inline-flex shrink-0">
    <ConnectorLogo
      name={name}
      fallback={<span className="text-sm font-medium">{name.charAt(0).toUpperCase()}</span>}
    />
    <span
      aria-hidden="true"
      className="absolute -right-1 -bottom-1 flex size-4 items-center justify-center rounded-full bg-brand-100 text-brand-800 ring-2 ring-background"
    >
      <Plug className="size-2.5" />
    </span>
  </span>
);
